import Navbar from '../../components/Navbar/Navbar'
import styles from './ClientPage.module.css'
import { useAppDispatch, useAppSelector } from '../../redux/types/types'
import {
  deleteClient,
  getClients,
  getCurrentClient,
  updateClient,
} from '../../redux/actions/clientsAction'
import { useEffect, useState } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import CustomButton from '../../components/UI/CustomButton/CustomButton'
import { getManagers } from '../../redux/actions/clientManagersAction'
import PATH from '../../navigation/path'
import { claimStatusesFromBack } from '../../constants/constants'
import CreateClientManagerModal from '../../components/CreateClientManagerModal/CreateClientManagerModal'
import iconEdit from '../../assets/icons/iconEdit.svg'
import IconTrashRed from '../../assets/icons/IconTrashRed.svg'
import { Formik, FormikValues } from 'formik'
import CustomInput from '../../components/UI/CustomInput/CustomInput'
import InputMask from 'react-input-mask'
import p from '../../components/UI/CustomInput/CustomInput.module.css'
import HeaderForCard from '../../components/HeaderForCard/HeaderForCard'
import CustomModal from '../../components/UI/CustomModal/CustomModal'
import DeleteComponent from '../../components/DeleteComponent/DeleteComponent'
import { useMediaQuery } from 'react-responsive'
import { useToast } from '../../context/ToastContext'

const ClientsPage = () => {
  const dispatch = useAppDispatch()
  const { token } = useAppSelector((state) => state.auth)
  const { clients, currentClient } = useAppSelector((state) => state.clients)
  const { managers, currentManager } = useAppSelector((state) => state.managers)
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [activePage, setActivePage] = useState(1)
  const [isEdit, setIsEdit] = useState(false)
  const { claimId } = useParams<{ claimId: string }>()
  const location = useLocation()
  const [submittedValues, setSubmittedValues] = useState<any>(null)
  const queryParams = new URLSearchParams(location.search)
  const clientId = queryParams.get('id')
  const clientType = currentClient?.type
  const navigate = useNavigate()
  const isMobile = useMediaQuery({ query: '(max-width: 768px)' })
  const onRedirectToEditCardPage = (id?: number) => {
    navigate(`${PATH.claimCardPage}${id ? id : claimId}`)
  }
  const { showSuccess, showError } = useToast()
  const [visiblePopup, setVisiblePopup] = useState<boolean>(false)

  const clientsRequests = currentClient?.requestIds

  const handleEditMode = () => {
    setIsEdit(!isEdit)
  }

  const handleDeleteClient = async () => {
    const resultAction = await dispatch(deleteClient({ id: Number(clientId), token }) as any)

    if (deleteClient.fulfilled.match(resultAction)) {
      showError('Клиент успешно удалён')
      navigate(`${PATH.clientControlPage}`)
    } else {
      showSuccess('Ошибка при удалении')
    }
  }

  const getClaimStatus = (statusKey: any): any => {
    if (!claimStatusesFromBack || typeof claimStatusesFromBack !== 'object') {
      return statusKey
    }
    return claimStatusesFromBack[statusKey]
  }

  const goBack = () => {
    window.history.back()
  }

  const onDeletePopup = () => {
    setVisiblePopup(true)
  }

  const handleSubmitHandler = async (values: FormikValues) => {
    setSubmittedValues({ ...values })

    const data = {
      role: 'client',
      contactPhone: values?.contactPhone,
      fullName: values?.fullName,
      phone: values?.phone,
      legalAddress: values?.address,
      contactFullName: values.fullName,
      organizationName: values?.organizationName,
      mailingAddress: values?.email,
      email: values.email,
      type: clientType,
      kpp: values?.kpp,
      ogrn: values?.ogrn,
      bankName: values?.bankName,
      signerPosition: values?.signerPostition,
    }

    dispatch(updateClient({ data: data, token, clientId: Number(clientId) }))
    handleEditMode()
  }

  useEffect(() => {
    if (token) {
      dispatch(getClients({ token }) as any)
      dispatch(getManagers({ token }) as any)
      dispatch(getCurrentClient({ id: Number(clientId), token }) as any)
    }
  }, [dispatch, token, isEdit])

  return (
    <div className={styles.clientsPageContainer}>
      <CustomModal visible={visiblePopup} setVisible={setVisiblePopup}>
        <DeleteComponent
          title='Удаление клиента'
          description='Хотите удалить данного клиента ?'
          onCancelHandler={() => setVisiblePopup(false)}
          onDeleteHandler={handleDeleteClient}
          deleteError={false}
        />
      </CustomModal>
      <Navbar />
      <div className={styles.clientsPage}>
        <CreateClientManagerModal
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(!isModalOpen)}
          clientId={Number(clientId)}
        />

        {clientType == 'legal' ? (
          <div className={styles.mainBlock}>
            <HeaderForCard
              deleteButton={
                <CustomButton
                  iconSrc={IconTrashRed}
                  className={styles.deleteBtn}
                  title={isMobile ? '' : 'Удалить клиента'}
                  onClick={onDeletePopup}
                />
              }
              title={currentClient?.organizationName ?? ''}
            />

            <div className={styles.topButtons}>
              <button
                className={activePage === 1 ? styles.activeButton : ''}
                onClick={() => setActivePage(1)}
              >
                Основная информация
              </button>
              <button
                className={activePage === 2 ? styles.activeButton : ''}
                onClick={() => setActivePage(2)}
              >
                Сотрудники Менеджеры
              </button>
              <button
                className={activePage === 3 ? styles.activeButton : ''}
                onClick={() => setActivePage(3)}
              >
                Заявки Организации
              </button>
            </div>

            {activePage === 1 && (
              <div className={styles.infoBlock}>
                {!isEdit && (
                  <div className={styles.header}>
                    <h2 className={styles.title}>Основная информация</h2>
                    <div className={styles.btnGroup}>
                      <CustomButton
                        iconSrc={iconEdit}
                        className={styles.btn}
                        title={''}
                        onClick={() => handleEditMode()}
                      />
                    </div>
                  </div>
                )}

                <div className={styles.main}>
                  {!isEdit ? (
                    <div className={styles.main}>
                      <div className={!isEdit ? styles.leftSide : styles.leftSideEdit}>
                        <h3>Название организации</h3>
                        <h3>ИНН</h3>
                        <h3>Адрес</h3>
                        <h3>Телефон организации</h3>
                        <h3>Электронная почта</h3>
                        <h3>ОГРН</h3>
                        <h3>КПП</h3>
                      </div>
                      <div className={styles.rightSide}>
                        <h3>{currentClient?.organizationName}</h3>
                        <h3>{currentClient?.inn}</h3>
                        <h3>{currentClient?.legalAddress}</h3>
                        <h3>{currentClient?.contactPhone}</h3>
                        <h3>{currentClient?.email}</h3>
                        <h3>{currentClient?.ogrn}</h3>
                        <h3>{currentClient?.kpp}</h3>
                      </div>
                    </div>
                  ) : (
                    <>
                      <Formik
                        initialValues={
                          submittedValues || {
                            organizationName: currentClient?.organizationName || '-',
                            inn: currentClient?.inn || '-',
                            legalAddress: currentClient?.legalAddress || '-',
                            contactPhone: currentClient?.contactPhone || '-',
                            email: currentClient?.email || '-',
                            ogrn: currentClient?.ogrn || '-',
                            kpp: currentClient?.kpp || '-',
                          }
                        }
                        validateOnBlur
                        onSubmit={(values) => handleSubmitHandler(values)}
                      >
                        {(props) => {
                          const { values, handleChange, handleBlur } = props

                          return (
                            <div className={styles.wrapperForm}>
                              <div className={styles.header}>
                                <h2 className={styles.title}>Основная информация</h2>
                                {isEdit && (
                                  <div className={styles.btnGroup}>
                                    <CustomButton
                                      className={styles.cancelBtn}
                                      title={'Отменить'}
                                      onClick={() => handleEditMode()}
                                    />
                                    <CustomButton
                                      className={styles.submitBtn}
                                      title={'Сохранить'}
                                      onClick={() => handleSubmitHandler(values)}
                                    />
                                  </div>
                                )}
                              </div>
                              <div className={styles.main}>
                                <div className={!isEdit ? styles.leftSide : styles.leftSideEdit}>
                                  <h3>Название организации</h3>
                                  <h3>ИНН</h3>
                                  <h3>Адрес</h3>
                                  <h3>Телефон организации</h3>
                                  <h3>ОГРН</h3>
                                  <h3>КПП</h3>
                                </div>
                                <div className={styles.editInputsBlock}>
                                  <div className={styles.inputGroup}>
                                    <CustomInput
                                      type='text'
                                      placeholder='Название организации'
                                      name='organizationName'
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                      value={values.organizationName}
                                    />
                                    <CustomInput
                                      type='text'
                                      placeholder='ИНН'
                                      name='INN'
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                      value={values.inn}
                                    />
                                    <CustomInput
                                      type='text'
                                      placeholder='Юридический Адрес'
                                      name='legalAddress'
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                      value={values.legalAddress}
                                    />
                                    <CustomInput
                                      type='text'
                                      placeholder='Номер телефона'
                                      name='contactPhone'
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                      value={values.contactPhone}
                                    />

                                    <CustomInput
                                      type='text'
                                      placeholder='ОГРН'
                                      name='ogrn'
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                      value={values.ogrn}
                                    />
                                    <CustomInput
                                      type='text'
                                      placeholder='КПП'
                                      name='kpp'
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                      value={values.kpp}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          )
                        }}
                      </Formik>
                    </>
                  )}
                </div>
              </div>
            )}

            {activePage === 2 && (
              <div className={styles.mainInfoBlock}>
                <div className={styles.createClientButtonBlock}>
                  <CustomButton
                    className={styles.createBtn}
                    title='Создать Менеджера'
                    onClick={() => setIsModalOpen(!isModalOpen)}
                  />
                </div>
                <div className={styles.tableContainer}>
                  {managers.length > 0 ? (
                    <table className={styles.tableContainer}>
                      <thead className={styles.tableHeader}>
                        <tr className={styles.tableHeaderRow}>
                          <th className={styles.headerItem}>ФИО</th>
                          <th className={styles.headerItem}>Email</th>
                          <th className={styles.headerItem}>Телефон</th>
                          <th className={styles.headerItem}>Заявки</th>
                          <th className={styles.headerItem}>Роль</th>
                        </tr>
                      </thead>
                      <tbody className={styles.tableBody}>
                        {managers.map((manager: any) => (
                          <tr className={styles.tableBodyRow} key={manager.id}>
                            <td className={styles.bodyItem}>{manager?.fullName || '—'}</td>
                            <td className={styles.bodyItem}>{manager?.email || '—'}</td>
                            <td className={styles.bodyItem}>{manager?.phone || '—'}</td>
                            <td className={styles.bodyItem}>
                              {manager?.requestIds?.length || '—'}
                            </td>
                            <td className={styles.bodyItem}>{manager?.position || '—'}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  ) : (
                    <p style={{ padding: '25px', textAlign: 'center', width: '100%' }}>
                      Сотрудники не найдены.
                    </p>
                  )}
                </div>
              </div>
            )}

            {activePage === 3 && (
              <div className={styles.tableWrapper}>
                {Array.isArray(clientsRequests) && clientsRequests.length > 0 ? (
                  <table className={styles.tableContainer}>
                    <thead className={styles.tableHeader}>
                      <tr className={styles.tableHeaderRow}>
                        <th className={styles.headerItem}>Сегмент</th>
                        <th className={styles.headerItem}>Статус заявки</th>
                        <th className={styles.headerItem}>Период</th>
                        <th className={styles.headerItem}>Кол-во гостей</th>
                      </tr>
                    </thead>
                    <tbody className={styles.tableBody}>
                      {currentClient?.requests?.map((req: any) => (
                        <tr
                          onClick={() => onRedirectToEditCardPage(req?.id)}
                          className={styles.tableBodyRow}
                          key={req?.id}
                        >
                          <td className={styles.bodyItem}>{req?.segment || '—'}</td>
                          <td className={styles.bodyItem}>{getClaimStatus(req?.status)}</td>
                          <td className={styles.bodyItem}>
                            {req?.createdAt ? new Date(req?.createdAt).toLocaleDateString() : '—'}-{' '}
                            {req?.endDate ? new Date(req?.endDate).toLocaleDateString() : '—'}
                          </td>
                          <td className={styles.bodyItem}>{req?.peopleCount || '—'} чел</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                ) : (
                  <div>
                    <table className={styles.clientsTable}>
                      <thead>
                        <tr>
                          <h3 style={{ padding: '25px' }}>Заявки не найдены</h3>
                        </tr>
                      </thead>
                    </table>
                  </div>
                )}
              </div>
            )}
          </div>
        ) : (
          <div className={styles.mainBlock}>
            <HeaderForCard
              deleteButton={
                <CustomButton
                  iconSrc={IconTrashRed}
                  className={styles.deleteBtn}
                  title={isMobile ? '' : 'Удалить клиента'}
                  onClick={onDeletePopup}
                />
              }
              title={currentClient?.fullName ?? ''}
            />

            <div className={styles.topButtons}>
              <button
                className={activePage === 1 ? styles.activeButton : ''}
                onClick={() => setActivePage(1)}
              >
                Основная информация
              </button>
              <button
                className={activePage === 3 ? styles.activeButton : ''}
                onClick={() => setActivePage(3)}
              >
                Заявки клиента
              </button>
            </div>

            {activePage === 1 && (
              <div className={styles.infoBlock}>
                {!isEdit && (
                  <div className={styles.header}>
                    <h2 className={styles.title}>Основная информация</h2>
                    <div className={styles.btnGroup}>
                      <CustomButton
                        iconSrc={iconEdit}
                        className={styles.btn}
                        title={''}
                        onClick={() => handleEditMode()}
                      />
                    </div>
                  </div>
                )}

                <div className={styles.main}>
                  {!isEdit ? (
                    <div className={styles.infoWrapper}>
                      <div className={styles.containerInfo}>
                        <div className={styles.wrapperInfo}>
                          <h3>ФИО</h3>
                        </div>
                        <h3 className={styles.valueContainer}>{currentClient?.fullName}</h3>
                      </div>
                      <div className={styles.containerInfo}>
                        <div className={styles.wrapperInfo}>
                          <h3>Телефон</h3>
                        </div>
                        <h3 className={styles.valueContainer}>{currentClient?.phone}</h3>
                      </div>
                    </div>
                  ) : (
                    <>
                      <Formik
                        initialValues={
                          submittedValues || {
                            fullName: currentClient?.fullName || '-',
                            phone: currentClient?.phone || '-',
                            email: currentClient?.email || '-',
                          }
                        }
                        validateOnBlur
                        onSubmit={(values) => handleSubmitHandler(values)}
                      >
                        {(props) => {
                          const { values, handleChange, handleBlur } = props

                          return (
                            <div className={styles.wrapperForm}>
                              <div className={styles.header}>
                                <h2 className={styles.title}>Основная информация</h2>
                                {isEdit && !isMobile && (
                                  <div className={styles.btnGroup}>
                                    <CustomButton
                                      className={styles.cancelBtn}
                                      title={'Отменить'}
                                      onClick={() => handleEditMode()}
                                    />
                                    <CustomButton
                                      className={styles.submitBtn}
                                      title={'Сохранить'}
                                      onClick={() => handleSubmitHandler(values)}
                                    />
                                  </div>
                                )}
                              </div>
                              <div className={styles.main}>
                                <div className={!isEdit ? styles.leftSide : styles.leftSideEdit}>
                                  <div className={styles.editContainerInfo}>
                                    <div className={styles.editWrapperInfo}>
                                      <div className={styles.editField}>
                                        <h3>ФИО</h3>
                                      </div>

                                      <div className={styles.inputGroup}>
                                        <CustomInput
                                          type='text'
                                          placeholder='ФИО клиента'
                                          name='fullName'
                                          onChange={handleChange}
                                          onBlur={handleBlur}
                                          value={values.fullName}
                                        />
                                      </div>
                                    </div>
                                    <div className={styles.editWrapperInfo}>
                                      <div className={styles.editField}>
                                        <h3>Номер телефона</h3>
                                      </div>
                                      <div className={styles.inputGroup}>
                                        <InputMask
                                          mask='+7 (999) 999 9999'
                                          type='phone'
                                          placeholder='Номер телефона'
                                          name='phone'
                                          required
                                          onChange={handleChange}
                                          onBlur={handleBlur}
                                          value={values.phone}
                                          className={p.input}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              {isEdit && isMobile && (
                                <div className={styles.btnGroups}>
                                  <CustomButton
                                    className={styles.cancelBtn}
                                    title={'Отменить'}
                                    onClick={() => handleEditMode()}
                                  />
                                  <CustomButton
                                    className={styles.submitBtn}
                                    title={'Сохранить'}
                                    onClick={() => handleSubmitHandler(values)}
                                  />
                                </div>
                              )}
                            </div>
                          )
                        }}
                      </Formik>
                    </>
                  )}
                </div>
              </div>
            )}

            {activePage === 3 && (
              <div className={styles.tableWrapper}>
                {Array.isArray(clientsRequests) && clientsRequests.length > 0 ? (
                  <table className={styles.tableContainer}>
                    <thead className={styles.tableHeader}>
                      <tr className={styles.tableHeaderRow}>
                        <th className={styles.headerItem}>Сегмент</th>
                        <th className={styles.headerItem}>Статус заявки</th>
                        <th className={styles.headerItem}>Период</th>
                        <th className={styles.headerItem}>Кол-во гостей</th>
                      </tr>
                    </thead>
                    <tbody className={styles.tableBody}>
                      {currentClient?.requests?.map((req: any) => (
                        <tr
                          onClick={() => onRedirectToEditCardPage(req?.id)}
                          className={styles.tableBodyRow}
                          key={req?.id}
                        >
                          <td className={styles.bodyItem}>{req?.segment || '—'}</td>
                          <td className={styles.bodyItem}>{getClaimStatus(req?.status)}</td>
                          <td className={styles.bodyItem}>
                            {req?.createdAt ? new Date(req?.createdAt).toLocaleDateString() : '—'} -{' '}
                            {req?.endDate ? new Date(req?.endDate).toLocaleDateString() : '—'}
                          </td>
                          <td className={styles.bodyItem}>{req?.peopleCount || '—'} чел</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                ) : (
                  <div>
                    <table className={styles.clientsTable}>
                      <thead>
                        <tr>
                          <h4 style={{ padding: '12px 24px', textAlign: 'center' }}>
                            Список заявок пуст
                          </h4>
                        </tr>
                      </thead>
                    </table>
                  </div>
                )}
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  )
}

export default ClientsPage
